import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import BlogCard from "./BlogsCards";
import Particle from "../Particle";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

import airCnc from "../../Assets/projectPic/Air-cnc.png";
import doctorsPortal from "../../Assets/projectPic/doctors-portal.png";
import hotOnion from "../../Assets/projectPic/hot-onion.png";
import travelGuru from "../../Assets/projectPic/Travel-guru.png";
import volentear from "../../Assets/projectPic/volentaer.png";
import algo from "../../Assets/projectPic/Travel-guru.png";
import fvaly from "../../Assets/projectPic/fvaly.PNG";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={fvaly}
              isBlog={false}
              title="F-Valy"
              description="F-valy is a E-commerce website. a website that allows you to buy tangible goods, digital products or services online.. "
              description2="Html,css, Bootstrap,JavaScript, react.js,TypeScipt , Redux"
              link="https://musing-euler-a6c4f1.netlify.app/"
              linkSource="https://github.com/Raihanuddin-anik/fvaly-ecommerce"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={airCnc}
              isBlog={false}
              title="Air-cnc"
              description="It's Air-cnc (Clone air-bnb) website for lodging, primarily homestays for vacation rentals, and tourism activities. "
              description2="Html,css, Bootstrap,JavaScript, react.js, CRUD(node.js, express,js, mongodb),heroKu"
              link="https://blissful-leavitt-c02abc.netlify.app/"
              linkSource="https://github.com/Raihanuddin-anik/air-cnc"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={volentear}
              isBlog={false}
              description2="Html,css, Bootstrap,JavaScript, react.js, CRUD(node.js, express,js, mongodb),HeroKu"
              title="Volunteer Network"
              description="A Volunteer Network Website where you can Select a organization to work You can remove add which organization you want.  "
              link="https://distracted-nobel-8eca94.netlify.app/"
              linkSource="https://github.com/Raihanuddin-anik/volenter-network"
            />
          </Col>

          <Col md={4} className="project-card">
         
            <ProjectCard
              imgPath={hotOnion}
              isBlog={false}
              description2="Html,css, Bootstrap,JavaScript, react.js, Firebase"
              title="hot Onion"
              description="A website of Restaurant There have filtered Item You can select each item. Items can be added to cart .  "
              link="https://zen-boyd-1c2845.netlify.app/"
              linkSource="https://github.com/Raihanuddin-anik/red-onion"
            />
           
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={travelGuru}
              isBlog={false}
              description2="Html,css,JavaScript, Bootstrap, react.js, Firebase, MeterialUi"
              title="Travel Guru"
              description="A Website for Travel Agency "
              link="https://hopeful-banach-dc48bf.netlify.app/"
              linkSource="https://github.com/Raihanuddin-anik/happy-traveling"
            /> 
          </Col>

        </Row>
        <h1 className="project-heading">
          My Recent <strong className="purple">Blog </strong> Posts
        </h1>
        <p style={{ color: "white" }}>Do give a read to some of my blogs</p>
        <Row style={{ justifyContent: "center" }}>
          <Col md={4} className="blog-card">
            <BlogCard
              imgPath={algo}
              link=""
              title=""
              site=""
            />
          </Col>
         
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
